import { AboutUs } from '@/features/consumer/about-us';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/(consumer)/_public/about-us')({
  component: AboutUs,
});
